import styled from 'styled-components'
import theme from '@app/ui/theme'

export const ModalBackdrop = styled.div<{ visible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.65);
  z-index: 99999999;
  display: ${({ visible }) => (visible ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
`

export const ModalContent = styled.div`
  text-align: center;
  border-radius: 12px;
  background-color: ${theme.colors.white};
  width: 400px;
  padding: 24px;
  box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
`

export const ModalTitle = styled.h2`
  font-weight: 600;
  font-size: 23px;
  margin: 0 0 12px 0;
  color: ${theme.colors.dark};
`

export const ModalDescription = styled.p`
  font-weight: 400;
  font-size: 16px;
  margin: 0 0 24px 0;
  color: ${theme.colors.dark};
`

export const ButtonRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
`

export const PrimaryButton = styled.button`
  width: 100%;
  max-width: 280px;
  height: 40px;
  background-color: ${theme.colors.primary};
  color: ${theme.colors.white};
  border: none;
  border-radius: ${theme.borderRadius}px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`

export const SecondaryButton = styled.button`
  width: 100%;
  max-width: 280px;
  height: 40px;
  background-color: ${theme.colors.background};
  color: ${theme.colors.primary2};
  border: 1px solid ${theme.colors.primary2};
  border-radius: ${theme.borderRadius}px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background-color: ${theme.colors.light};
  }
`

export const CancelButton = styled.button`
  width: 100%;
  max-width: 280px;
  height: 40px;
  background-color: transparent;
  color: ${theme.colors.dark2};
  border: none;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`
